import { Fragment, memo } from "react";
import AdUnit, { AdUnitTypeEnum } from "./AdUnit";
import { AdUnitsKeys } from "./config/units";
import { deviceTypeEnum, useDeviceType } from "hooks/useDeviceType";

interface IProps {
  position: number;
  mobileAds: AdUnitsKeys[];
  desktopAds: AdUnitsKeys[];
}

const AD_POSITION_FACTOR = 4;

export const ScrollAdDispatcher = memo((props: IProps) => {
  const { position, mobileAds, desktopAds } = props;

  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  const canShow = position % AD_POSITION_FACTOR === 0;
  const index = (position / AD_POSITION_FACTOR) - 1;
  const currentAds = isDesktop ? desktopAds : mobileAds;
  const type = isDesktop ? AdUnitTypeEnum.DESKTOP : AdUnitTypeEnum.MOBILE;

  return (
    <Fragment>
      {
        canShow && currentAds[index] && (
          <AdUnit name={currentAds[index]} type={type}/>
        )
      }
    </Fragment>
  );
});
